var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"under_maintenance_page_content"},[_c('div',{staticClass:"public_bg_clr_wrp"},[_c('div',{staticClass:"under_maintenance_page_content_inner"},[_c('article',{staticClass:"text-center"},[_c('h1',[_vm._v("Page under Maintenance")])])])])])
}]

export { render, staticRenderFns }